/* MC Wishlist Plus
   Follows the approved canvas (MC Wishlist Improvements):
   1  Save to list + "Keep this list" email capture (unknown visitors)
   2  After email sent: "List sent to {email}"
   2b Known contact: "Saved to {list}. Find it any time under Saved items."
   3  Saved items panel: inline "Email me this list" (unknown visitors)
   Styling reuses the theme's existing .mc-wishlist__* classes. mc-wishlist.js is NOT modified.
   Omnisend: subscribe via the existing Vercel endpoint, then omnisend.identifyContact so
   wishlist events are recorded. Also identifies logged-in customers and popup subscribers. */
(function () {
  if (window.__mcWishlistPlus) return;
  window.__mcWishlistPlus = true;

  var CFG = window.MC_WL || {};
  var ENDPOINT = CFG.endpoint || '';
  var KNOWN_KEY = 'mc_wl_known';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var justSent = '';
  var pendingList = false;

  /* ---------- "Email me this list": one Omnisend event with every saved product ---------- */
  function money(n) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD', maximumFractionDigits: n % 1 ? 2 : 0 }).format(n); }
    catch (e) { return '$' + n; }
  }
  function sendListEvent() {
    var items = [];
    try { items = (window.MCWishlist && MCWishlist.all()) || []; } catch (e) {}
    var api = window.MCWishlistOmnisend;
    if (!items.length || !api || !api.buildProduct) return;
    Promise.all(items.slice(0, 8).map(function (it) {
      return api.buildProduct({ productId: it.id, variantId: it.variantId, title: it.title, price: it.price, url: it.url, handle: it.handle });
    })).then(function (list) {
      var products = list.filter(function (p) { return p && p.title; }).map(function (p) {
        return { title: p.title, price: p.price ? money(p.price) : '', url: p.url, image: p.imageUrl };
      });
      if (!products.length) return;
      try {
        window.omnisend = window.omnisend || [];
        window.omnisend.push(['track', 'wishlist list requested', {
          origin: 'api',
          properties: { products: products, item_count: products.length, list_name: lastListName || 'My Wishlist' }
        }]);
      } catch (e) {}
    });
  }
  // Fire only after the contact is identified, otherwise Omnisend drops the event.
  document.addEventListener('mc:omnisend:identified', function () {
    if (!pendingList) return;
    pendingList = false;
    setTimeout(sendListEvent, 800);
  });
  var lastListName = '';
  var uidN = 0;

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

  function isKnown() {
    return !!CFG.customerEmail || lsGet(KNOWN_KEY) === '1' || lsGet('mc-np-sub') === '1';
  }
  function publish(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }

  /* ---------- Omnisend identify ---------- */
  function identify(email) {
    if (!email) return;
    var tries = 0;
    (function attempt() {
      var o = window.omnisend;
      if (o && typeof o.identifyContact === 'function') {
        try { o.identifyContact({ email: email }); } catch (e) {}
        lsSet(KNOWN_KEY, '1');
        try { document.dispatchEvent(new CustomEvent('mc:omnisend:identified', { detail: { email: email } })); } catch (e) {}
        return;
      }
      if (++tries < 40) setTimeout(attempt, 250);
    })();
  }

  if (CFG.customerEmail && ssGet('mc_wl_identified') !== '1') {
    ssSet('mc_wl_identified', '1');
    identify(CFG.customerEmail);
  }

  // Newsletter popup: identify after a real successful signup (popup file untouched).
  document.addEventListener('submit', function (e) {
    var f = e.target && e.target.closest ? e.target.closest('[data-mc-np-form]') : null;
    if (!f) return;
    var hp = f.querySelector('[name="company"]');
    if (hp && hp.value) return;
    var emEl = f.querySelector('[data-mc-np-email]');
    var em = emEl ? emEl.value.trim() : '';
    if (!EMAIL_RE.test(em)) return;
    var succ = document.querySelector('[data-mc-np-success]');
    if (!succ) return;
    var mo = new MutationObserver(function () {
      if (!succ.hidden) { mo.disconnect(); identify(em); }
    });
    mo.observe(succ, { attributes: true, attributeFilter: ['hidden'] });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }, true);

  /* ---------- Subscribe ---------- */
  function shopifyPost(email) {
    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '\u2713');
    fd.append('contact[email]', email);
    fd.append('contact[tags]', 'newsletter,wishlist');
    return fetch(root + 'contact', { method: 'POST', body: fd, headers: { 'Accept': 'text/html' }, credentials: 'same-origin' }).catch(function () {});
  }
  function subscribe(email) {
    var req;
    if (ENDPOINT) {
      req = fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email, phone: '', sms_consent: false, phone_required: false,
          page_url: location.href, offer: 'Wishlist', presentation: 'wishlist',
          source: 'wishlist', company: ''
        })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          if (!r.ok || !d.ok) { var err = new Error('subscribe'); err.field = d && d.field; throw err; }
          return d;
        });
      });
    } else {
      req = Promise.resolve({ ok: true });
    }
    return req.then(function () {
      shopifyPost(email);
      lsSet('mc-np-sub', '1');
      identify(email);
      publish('mc_wishlist_signup', { source: 'wishlist' });
      return true;
    });
  }

  /* ---------- Markup (theme classes) ---------- */
  var HP = '<label class="mc-wl-hp" aria-hidden="true">Company<input type="text" name="company" tabindex="-1" autocomplete="off"></label>';
  var FINE = '<p class="mc-wishlist__create-title mc-wl-fine">You\u2019ll also get Modern Contempo emails. Unsubscribe anytime.</p>';
  var ERR = '<p class="mc-wl-error" role="alert" hidden></p>';

  function panelFormHTML() {
    return '<form class="mc-wl-capture" data-mc-wl-capture novalidate>' +
      '<p class="mc-wishlist__listbar-name mc-wl-kicker">KEEP THIS LIST</p>' +
      '<p class="mc-wishlist__listempty mc-wl-text">Email it to yourself, or to someone at home who\u2019s helping you decide.</p>' +
      '<div class="mc-wishlist__create-row">' +
        '<input class="mc-wishlist__create-input" type="email" name="email" autocomplete="email" placeholder="you@example.com" aria-label="Email address" required>' +
      '</div>' + HP + ERR +
      '<button type="submit" class="mc-wishlist__btn mc-wl-full">Email me this list</button>' +
      FINE +
    '</form>';
  }
  function inlineFormHTML() {
    var id = 'mc-wl-email-' + (++uidN);
    return '<form class="mc-wl-capture" data-mc-wl-capture novalidate>' +
      '<label class="mc-wishlist__create-title" for="' + id + '">Email me this list</label>' +
      '<div class="mc-wishlist__create-row">' +
        '<input id="' + id + '" class="mc-wishlist__create-input" type="email" name="email" autocomplete="email" placeholder="you@example.com" required>' +
        '<button type="submit" class="mc-wishlist__create-btn">Send</button>' +
      '</div>' + HP + ERR + FINE +
    '</form>';
  }
  var CHECK = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var MAIL = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M4 7h16v11H4zM4 7l8 6 8-6" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>';
  function sentHTML(email) {
    return '<div class="mc-wishlist__listrow mc-wl-note" role="status">' + CHECK +
      '<div><span class="mc-wishlist__listname">List sent to ' + esc(email) + '</span>' +
      '<p class="mc-wishlist__listbar-name">It stays saved here too, on this device.</p></div></div>';
  }
  function knownHTML() {
    var name = lastListName || 'your list';
    return '<div class="mc-wishlist__listrow mc-wl-note" role="status">' + MAIL +
      '<p class="mc-wishlist__listbar-name">Saved to ' + esc(name) + '. Find it any time under Saved items.</p></div>';
  }

  /* ---------- Inject into the panel ---------- */
  function bodyEl() { return document.querySelector('[data-mc-wishlist-body]'); }

  function render(force) {
    var b = bodyEl();
    if (!b) return;
    var existing = b.querySelector('[data-mc-wl-plus]');
    if (existing && !force) return;
    if (existing) {
      // put the theme's "View saved items" button back before removing our footer
      var doneIn = existing.querySelector('.mc-wishlist__done');
      if (doneIn) b.appendChild(doneIn);
      existing.parentNode.removeChild(existing);
    }
    var empty = b.querySelector('.mc-wishlist__empty');
    if (empty) {
      // "Start shopping" goes to the homepage
      var shop = empty.querySelector('a[href]');
      if (shop && shop.getAttribute('href') !== root) shop.setAttribute('href', root);
      return;
    }

    var lists = b.querySelector('.mc-wishlist__lists');
    var tabs = b.querySelector('.mc-wishlist__tabs');
    var hasItems = !!b.querySelector('.mc-wishlist__item');
    var html = '';
    if (lists) html = justSent ? sentHTML(justSent) : (isKnown() ? knownHTML() : panelFormHTML());
    else if (tabs) html = justSent ? sentHTML(justSent) : ((isKnown() || !hasItems) ? '' : inlineFormHTML());
    if (!html) return;

    // Footer pinned to the bottom of the panel (fills the empty space, thumb-reachable on mobile)
    var wrap = document.createElement('div');
    wrap.className = 'mc-wl-plus mc-wl-foot';
    wrap.setAttribute('data-mc-wl-plus', '');
    wrap.innerHTML = html;
    var done = lists ? b.querySelector('.mc-wishlist__done') : null;
    if (done) { b.insertBefore(wrap, done); wrap.appendChild(done); }
    else b.appendChild(wrap);
  }

  function watch() {
    var b = bodyEl();
    if (!b) { setTimeout(watch, 300); return; }
    new MutationObserver(function () { render(false); }).observe(b, { childList: true });
    var pop = document.querySelector('[data-mc-wishlist]');
    if (pop) {
      new MutationObserver(function () { if (pop.hidden) justSent = ''; })
        .observe(pop, { attributes: true, attributeFilter: ['hidden'] });
    }
    render(false);
  }

  document.addEventListener('mc:wishlist:add', function (e) {
    var d = (e && e.detail) || {};
    if (d.listName) lastListName = d.listName;
  });

  document.addEventListener('submit', function (e) {
    var f = e.target && e.target.closest ? e.target.closest('[data-mc-wl-capture]') : null;
    if (!f) return;
    e.preventDefault();
    e.stopPropagation();
    var input = f.querySelector('input[name="email"]');
    var hp = f.querySelector('input[name="company"]');
    var err = f.querySelector('.mc-wl-error');
    var btn = f.querySelector('button[type="submit"]');
    var email = input ? input.value.trim() : '';

    function showErr(msg) {
      if (err) { err.textContent = msg; err.hidden = false; }
      if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
    }
    if (err) err.hidden = true;
    if (input) input.removeAttribute('aria-invalid');
    if (hp && hp.value) return;
    if (!EMAIL_RE.test(email)) return showErr('Please enter a valid email address.');

    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Sending\u2026'; }
    pendingList = true;
    subscribe(email).then(function () {
      justSent = email;
      render(true);
    }).catch(function (x) {
      pendingList = false;
      if (btn) { btn.disabled = false; btn.textContent = label; }
      showErr(x && x.field === 'email' ? 'Please enter a valid email address.' : 'Something went wrong. Please try again.');
    });
  }, true);

  if (document.readyState !== 'loading') watch();
  else document.addEventListener('DOMContentLoaded', watch);
})();
